// Mock data for Stay Tran-Quil cabin rental website

export const heroData = {
  tagline: "Stay Tran-Quil on the River",
  subtitle: "Escape to 1.5 acres of private riverfront paradise between Lac du Bonnet and Powerview–Pine Falls, Manitoba",
  backgroundImage: "https://images.unsplash.com/photo-1650513452784-c91c0436f6d5?auto=format&fit=crop&w=1920&q=80"
};

export const aboutData = {
  title: "Your Riverfront Retreat",
  description: "Nestled on the serene banks of the Winnipeg River, Stay Tran-Quil offers the perfect escape from the everyday. Our cozy cabin sits on 1.5 acres of private riverfront land, providing an intimate connection with nature while ensuring all the comforts of home.",
  amenities: [
    { name: "Fully Equipped Kitchen", icon: "UtensilsCrossed" },
    { name: "Cozy Fireplace", icon: "Flame" },
    { name: "Private Dock", icon: "Anchor" },
    { name: "WiFi Available", icon: "Wifi" },
    { name: "BBQ Grill", icon: "Beef" },
    { name: "Outdoor Fire Pit", icon: "Tent" },
    { name: "Sleeps 6 Guests", icon: "Users" },
    { name: "Pet Friendly", icon: "PawPrint" }
  ]
};

export const galleryData = {
  title: "Glimpses of Paradise",
  images: [
    {
      src: "https://images.unsplash.com/photo-1653051993873-071d589ba16e?auto=format&fit=crop&w=800&q=80",
      alt: "Cabin exterior surrounded by nature",
      caption: "Cabin Exterior"
    },
    {
      src: "https://images.unsplash.com/photo-1712669869857-c9c0c098d024?auto=format&fit=crop&w=800&q=80",
      alt: "Cozy cabin interior with fireplace",
      caption: "Cozy Interior"
    },
    {
      src: "https://images.unsplash.com/photo-1717964134799-a98f497172a5?auto=format&fit=crop&w=800&q=80",
      alt: "Beautiful river view from the property",
      caption: "River Views"
    },
    {
      src: "https://images.unsplash.com/photo-1656740978179-91ed1b1e745b?auto=format&fit=crop&w=800&q=80",
      alt: "Peaceful forest surroundings",
      caption: "Forest Setting"
    }
  ]
};

export const activitiesData = {
  title: "Adventures Await",
  subtitle: "Experience the best of Manitoba's outdoor recreation",
  activities: [
    {
      name: "Fishing",
      description: "Cast your line into the pristine waters of the Winnipeg River, home to walleye, northern pike, and smallmouth bass.",
      icon: "Fish",
      season: "Year-round"
    },
    {
      name: "Hunting",
      description: "Access prime hunting grounds for deer, moose, and waterfowl in the surrounding wilderness.",
      icon: "Target",
      season: "Seasonal"
    },
    {
      name: "Boating",
      description: "Launch your boat from our private dock and explore miles of scenic waterways.",
      icon: "Ship",
      season: "Spring-Fall"
    },
    {
      name: "Hiking",
      description: "Discover scenic trails through boreal forests and along the riverbank right from our property.",
      icon: "Mountain",
      season: "Year-round"
    },
    {
      name: "Wildlife Viewing",
      description: "Spot eagles, deer, beavers, and countless bird species in their natural habitat.",
      icon: "Binoculars",
      season: "Year-round"
    },
    {
      name: "Winter Activities",
      description: "Enjoy ice fishing, snowshoeing, cross-country skiing, and cozy nights by the fire.",
      icon: "Snowflake",
      season: "Winter"
    }
  ]
};

export const footerData = {
  contact: {
    email: "info@staytranquil.ca",
    phone: "+1 (204) 555-0123",
    address: "Winnipeg River, Manitoba"
  },
  social: {
    instagram: "#",
    facebook: "#",
    twitter: "#"
  },
  bookingUrl: "#booking"
};
